import styled, { css } from "styled-components";

interface IInputWrapper {
  $focus: boolean;
}

export const InputWrapper = styled.div<IInputWrapper>`
  flex: 1;
  display: flex;
  align-items: center;
  min-width: 180px;
  width: 100%;
  height: 32px;
  padding: 0 12px 0 6px;
  border-radius: 6px;
  gap: 2px;
  background-color: ${({ theme }) => theme.colors.secondary.secondary};

  .iconSearch {
    color: ${({ theme }) => theme.colors.secondary.onSecondaryVariant} !important;
  }

  .input {
    flex: 1;
    border: none;
    width: 100%;
    height: 100%;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    background-color: transparent;
    outline: none;

    &::placeholder {
      color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder};
    }
  }

  ${({ $focus }) => $focus && css`
    border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
    background-color: ${({ theme }) => theme.colors.surface.surface};

    .iconSearch {
      color: ${({ theme }) => theme.colors.primary.primary} !important;
    }
  `}
`;
